import { ThemeProvider } from 'styled-components';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import React from 'react';
import { useTriggerOptimizelyActivation } from '@pb/vendor/optimizely';
import { GlobalStyle, defaultTheme } from '@pb/styles';
import { WebViewProvider } from '@pb/shared/contexts/webview';

import { OfferDetailsProvider } from '@pb/apps/offers/context/offer-details';

const queryCache = new QueryCache();

export default function Properties({ Component, pageProps }: any) {
    useTriggerOptimizelyActivation(pageProps.optimizelyId);

    return (
        <ReactQueryCacheProvider queryCache={queryCache}>
            <ThemeProvider theme={defaultTheme}>
                <GlobalStyle />
                <WebViewProvider>
                    <OfferDetailsProvider>
                        <Component {...pageProps} />
                    </OfferDetailsProvider>
                </WebViewProvider>
            </ThemeProvider>
        </ReactQueryCacheProvider>
    );
}
